export default __webpack_public_path__ + "static/media/bg-header-mobile.9cb13612.svg";